import React from 'react';
import { ShieldCheck, Clock, Star, ThumbsUp, MapPin, Zap } from 'lucide-react';
const reasons = [{
  icon: <ShieldCheck size={24} data-id="element-144" />,
  title: 'Licensed & Insured',
  description: 'Fully licensed and insured for your peace of mind on every job.'
}, {
  icon: <Clock size={24} data-id="element-145" />,
  title: 'Reliable & On Time',
  description: 'We show up when we say we will — no waiting around, no excuses.'
}, {
  icon: <Star size={24} data-id="element-146" />,
  title: 'Elite Results',
  description: "We take pride in every job. If it doesn't look elite, we're not done."
}, {
  icon: <ThumbsUp size={24} data-id="element-147" />,
  title: 'Honest Pricing',
  description: "Transparent quotes with no hidden fees. You know exactly what you're paying."
}, {
  icon: <MapPin size={24} data-id="element-148" />,
  title: 'Arizona Local',
  description: "We know AZ pools — the heat, the hard water, the desert conditions. We've got you."
}, {
  icon: <Zap size={24} data-id="element-149" />,
  title: 'Fast Turnaround',
  description: 'Quick scheduling and efficient service so your backyard is back in action ASAP.'
}];
export function WhyUs() {
  return <section id="why-us" className="w-full bg-[#0d1117] pt-12 pb-12 sm:py-20 px-4 sm:px-6" data-id="element-150">
      <div className="max-w-6xl mx-auto" data-id="element-151">
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-152">
          {/* Left: image */}
          <div className="lg:w-1/2 w-full" data-id="element-153">
            <div className="relative rounded-2xl overflow-hidden" data-id="element-154">
              <img src="https://cdn.magicpatterns.com/uploads/41rnj77y6oBHYW2mGYjfha/Screenshot_2026-07-10_104206.png" alt="Modern pool and spa maintained by Elite Poolz" className="w-full h-80 lg:h-[480px] object-cover" data-id="element-155" />
              <div className="absolute inset-0 border-2 border-[#2979ff]/30 rounded-2xl pointer-events-none" data-id="element-156" />
              {/* Badge */}
              <div className="absolute bottom-6 left-6 bg-[#0d1117]/90 border border-[#2979ff] rounded-xl px-5 py-3" data-id="element-157">
                <p className="text-[#2979ff] font-black text-2xl" data-id="element-158">AZ</p>
                <p className="text-white text-xs font-semibold" data-id="element-159">
                  Serving Arizona
                </p>
              </div>
            </div>
          </div>

          {/* Right: reasons */}
          <div className="lg:w-1/2 w-full text-center lg:text-left" data-id="element-160">
            <span className="text-[#2979ff] text-sm font-bold tracking-widest uppercase" data-id="element-161">
              Why Elite Poolz
            </span>
            <h2 className="text-3xl sm:text-4xl font-black text-white mt-2 mb-8" data-id="element-162">
              The Difference Is in the Details
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-163">
              {reasons.map(r => <div key={r.title} className="flex flex-col items-center gap-2 sm:flex-row sm:items-start sm:gap-4" data-id="element-164">
                  <div className="text-[#2979ff] mt-0.5 shrink-0" data-id="element-165">{r.icon}</div>
                  <div data-id="element-166">
                    <h3 className="text-white font-bold text-base mb-1" data-id="element-167">
                      {r.title}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-168">
                      {r.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}